<script lang="ts">
    import Comparison from '$lib/components/comparison/comparison.svelte';

    const comparedTo = 'Anki'

    const keyDifferences = 'While both use spaced repetition, <b>vocabeo</b> provides ready-made frequency-based content and context-rich examples, whereas <b>Anki</b> requires users to create or import their own flashcard decks.'

    const vocabeoApproach = [
        'Pre-made, frequency-sorted vocabulary list',
        'Word classification by proficiency level and part of speech',
        'Built-in example sentences with audio and images',
        'Integrated cloze exercises with typing option',
        'Progress tracking with detailed statistics',
    ]

    const comparedToApproach = [
        'User-created or imported flashcard decks',
        'Flexible card template system',
        'Full control over content and learning structure',
        'Customizable spaced repetition algorithm',
        'Limited built-in progress analytics',
    ]

    const chooseVocabeoIf = [
        'Prefer a pre-made, frequency-based vocabulary list without manually creating flashcards',
        'Want example sentences with audio and images',
        'Prefer a streamlined interface specifically designed for vocabulary acquisition',
        'Like exercises with built-in typing practice',
        'Want to track your progress with detailed statistics',
    ]

    const chooseComparedTo = [
        'Want complete control over your flashcard content and formatting',
        'Need to study specialized or technical vocabulary not typically found in language apps',
        'Prefer creating your own study materials from scratch',
        'Like having extensive customization options for your spaced repetition algorithm',
        'Want to use the same system for multiple subjects beyond language learning',
    ]

    const comparedToLink = 'https://apps.ankiweb.net/'

    const ifYou = 'prefer complete control over your learning materials and don\'t mind creating your own flashcards'
</script>

<svelte:head>
    <title>vocabeo vs Anki</title>

    <meta name="description"
          content="vocabeo vs Anki — Which is right for you? Compare key differences, learning approaches, and find the best fit for your language goals.">
</svelte:head>

<Comparison
        comparedTo={comparedTo}
        keyDifferences={keyDifferences}
        vocabeoApproach={vocabeoApproach}
        comparedToApproach={comparedToApproach}
        chooseVocabeoIf={chooseVocabeoIf}
        chooseComparedTo={chooseComparedTo}
        comparedToLink={comparedToLink}
        ifYou={ifYou}
/>
